import { FC } from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface UnansweredFilterProps {
  showOnlyUnanswered: boolean;
  onToggle: (value: boolean) => void;
}

const UnansweredFilter: FC<UnansweredFilterProps> = ({
  showOnlyUnanswered,
  onToggle,
}) => (
  <Tooltip
    title={
      showOnlyUnanswered
        ? 'Showing unanswered questions only'
        : 'Show only unanswered questions'
    }
  >
    <ToggleButtonGroup
      size="small"
      value={showOnlyUnanswered ? 'unanswered' : 'all'}
      exclusive
      onChange={(_, val) => {
        if (val !== null) {
          onToggle(val === 'unanswered');
        }
      }}
    >
      <ToggleButton value="all">
        <VisibilityIcon sx={{ fontSize: 18, mr: 0.5 }} />
        All
      </ToggleButton>
      <ToggleButton value="unanswered">
        <VisibilityOffIcon sx={{ fontSize: 18, mr: 0.5 }} />
        Unanswered
      </ToggleButton>
    </ToggleButtonGroup>
  </Tooltip>
);

export default UnansweredFilter;
